import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

const ffmpeg = new FFmpeg();

export const getFFmpeg = async () => {
  if (!ffmpeg.loaded) {
    await ffmpeg.load();
  }
  return ffmpeg;
};

export { fetchFile };